import styled from '@emotion/styled';

import { withTheme } from 'emotion-theming';

import {
  disabledColor,
  errorColor,
  primaryColor,
  warningColor,
} from '@zego/theme';

const Input = styled('input')(
  {
    padding: '15px 17px',
    color: disabledColor(10),
    fontSize: 16,
    fontWeight: 'normal',
    margin: 0,
    width: '100%',
    '&::placeholder': {
      color: disabledColor(5),
      overflow: 'visible',
    },
    '&[type=number]': {
      MozAppearance: 'textfield',
    },
    '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
  },
  props => {
    const { inputOverides = {} } = props.theme;
    const { borderRadius = 4 } = inputOverides;
    const iconSize = props.iconSize || (props.icon ? 50 : undefined);
    // statusIcon to indicate a warning or error flag
    const statusIconSize = props.warning ? 50 : undefined;
    const getBorderColor = () => {
      if (props.error) return errorColor(5);
      if (props.warning) return warningColor(5);
      return disabledColor(4);
    };
    const borderWidth = 1;
    return {
      borderRadius: borderRadius,
      textTransform: props.textTransform || 'none',
      paddingLeft: iconSize,
      paddingRight: statusIconSize,
      border: `${borderWidth}px solid ${getBorderColor()}`,
      '&:focus': {
        padding: '14px 16px',
        paddingLeft: iconSize ? iconSize - borderWidth : undefined,
        paddingRight: statusIconSize
          ? statusIconSize - borderWidth
          : undefined,
        outline: 'none',
        border: `${borderWidth * 2}px solid ${
          props.theme.tintColor || primaryColor()
        }`,
      },
      ...inputOverides,
    };
  },
);

export default withTheme(Input);
